module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_mail_color-2df51afc0c951b3b365ce40ec3963a22.svg";